import type { Rc } from '@zinc/shared';
import { x0, y0 } from './geom';
import { CORNER_LABEL, FONT, INK, WHITE } from './style';

/** A small number in a cell's top-left corner on a background patch (cage sums, labels). */
export function CornerLabel({ cell, text }: { cell: Rc; text: string }) {
  const [r, c] = cell;
  return (
    <g data-label={text}>
      <rect
        x={x0(c) + 1.5}
        y={y0(r) + 1.5}
        width={text.length * 5.6 + 2}
        height={10}
        fill={WHITE}
      />
      <text
        x={x0(c) + 2.5}
        y={y0(r) + 6.8}
        fontFamily={FONT}
        fontSize={CORNER_LABEL.size}
        fontWeight={CORNER_LABEL.weight}
        fill={INK}
        dominantBaseline="central"
      >
        {text}
      </text>
    </g>
  );
}
